import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/orders',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function update(ctx, data = {}) {
  try {
    const id = data.id
    delete data.id
    const response = await api({
      url: `/orders/${id}`,
      data,
      method: 'PUT'
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('orders', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function share(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('orders', queryParams) + `/share`,
      params: queryParams,
      method: 'POST'
    })
    ctx.commit('share', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function invite(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('orders', queryParams) + `/invite`,
      params: queryParams,
      method: 'POST'
    })
    ctx.commit('share', response.data)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}
